import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { financialService } from "../services/financialService";

export function useFinancialSummary() {
  return useQuery({
    queryKey: ["financial", "summary"],
    queryFn: financialService.getFinancialSummary,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
}

export function usePayments() {
  return useQuery({
    queryKey: ["financial", "payments"],
    queryFn: financialService.getPayments,
    staleTime: 1000 * 60 * 5,
  });
}

export function useCurrentModule() {
  return useQuery({
    queryKey: ["financial", "currentModule"],
    queryFn: financialService.getCurrentModule,
    staleTime: 1000 * 60 * 5,
  });
}

export function useModuleProgress() {
  return useQuery({
    queryKey: ["financial", "progress"],
    queryFn: financialService.getModuleProgress,
    staleTime: 1000 * 60 * 5,
  });
}

export function useUploadReceipt() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ paymentId, file }: { paymentId: string; file: File }) =>
      financialService.uploadReceipt(paymentId, file),
    onSuccess: () => {
      toast.success("Receipt uploaded successfully!");
      // Invalidate related queries
      queryClient.invalidateQueries({ queryKey: ["financial"] });
    },
    onError: (error: Error) => {
      toast.error(error.message || "Failed to upload receipt");
    },
  });
}

export function useRemoveReceipt() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (paymentId: string) =>
      financialService.removeReceipt(paymentId),
    onSuccess: () => {
      toast.success("Receipt removed successfully!");
      // Invalidate related queries
      queryClient.invalidateQueries({ queryKey: ["financial"] });
    },
    onError: (error: Error) => {
      toast.error(error.message || "Failed to remove receipt");
    },
  });
}
